/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Allowance
 */
export enum AllowanceType {
    Wardrobe_Fee = 'Wardrobe Fee',
    Wardrobe_FeeEvePeriod = 'Wardrobe Fee - Eve/Period',
    LocationMeal_Breakfast = 'Breakfast',
    LocationMeal_Lunch = 'Lunch',
    LocationMeal_Dinnner = 'Dinnner',
    Travel_ExtrasRoundTrip = 'Extras - Round Trip',
    Travel_PerMileOutsideStudioZone = 'Per mile (outside studio zone)',
    Travel_OCPPerDiem = 'OCP travel per diem',
    Props_AutomobileTrailerMotorcycle = 'Automobile, Trailer or Motorcycle',
    Props_SkatesSkateBoards = 'Skates and Skate Boards',
    Props_Bicycle = 'Bicycle',
    Props_Moped = 'Moped',
    Props_Camera = 'Camera',
    Props_Pet = 'Pet',
    Props_LuggageEachPiece = 'Luggage (each piece)',
    Props_GolfClubsAndBag = 'Golf Clubs & Bag',
    Props_TennisRacquet = 'Tennis Racquet',
    Props_Skis = 'Skis',
    Props_BinocularsOperaGlasses = 'Binoculars or Opera Glasses',
    Props_LargePortableRadios = 'Large Portable Radios',
    Props_BooksEach = 'Books (each)',
    Props_LaptopCellPhonePDAiPodMP3Player = 'Laptop, Cell Phone/PDA, iPod/MP3 Player',
    Props_StandardOpeningOrClosing = 'Standard Opening or Closing',
    Props_WetSnowmokeDustWork = 'Wet, Snow, Smoke, & Dust Work',
    Props_BodyMUSkullCapHairGoodsHaircuts = 'Body MU, Skull Cap, Hair Goods, Haircuts',
}
